import { z } from 'zod'

import { Status } from './status.enum'

export let admissionAndProcedureClaimSchema = z.object({
  id: z.string(),

  description: z.array(
    z.object({
      code: z.string()
        .nullable()
        .optional(),

      descriptor: z.string()
        .nullable()
        .optional()
    })
  )
    .nullable()
    .optional(),

  service_date: z.string()
    .optional()
    .nullable(),

  provider_name: z.string()
    .optional()
    .nullable(),

  procedure: z.object({
    code: z.string()
      .nullable()
      .optional(),

    descriptor: z.string()
      .nullable()
      .optional()
  })
    .nullable()
    .optional(),

  place_of_service: z.string()
    .optional()
    .nullable(),

  status: z.nativeEnum(Status)
    .nullable()
    .optional()
})

export let admissionAndProcedureClaimsSchema = z.array(admissionAndProcedureClaimSchema)
